/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CaseMatchCaseDiagnosis = {
    readonly id?: number;
    specimen: number;
    readonly specimen_id?: number;
    diagnosis: string;
    microscopic?: string | null;
    comment?: string | null;
    source: CaseMatchCaseDiagnosis.source;
    version?: number | null;
    is_completed?: boolean;
    readonly finalized_report_id?: number;
}

export namespace CaseMatchCaseDiagnosis {

    export enum source {
        AI = 'ai',
        SCREEN = 'screen',
        FINALIZE = 'finalize',
        LIS_FINALIZED = 'lis-finalized',
        COMMENT = 'comment',
        AMEND = 'amend',
        ADDEND = 'addend',
        CORRECTION = 'correction',
        PRELIMINARY = 'preliminary',
    }


}
